import React from 'react';
import { intlShape } from 'react-intl';
import { array, shape, bool, string } from 'prop-types';
import { PackageHeader, Box } from '@landtrustinc/design-system';

import usePackageData from '../../../hooks/usePackageData';
import useHeader from '../../../hooks/useHeader';
import { propTypes } from '../../../util/types';

const PackageHeaderSection = ({
  listing,
  packageId,
  listingParams,
  reviews,
  reviewsMeta,
  isFetchingReviews,
  intl,
}) => {
  const packageData = usePackageData({ listing, packageId, intl });

  const { header, subheader, features } = useHeader({
    data: packageData,
    listingParams,
    reviews,
    reviewsMeta,
    isFetchingReviews,
    intl,
  });

  return (
    <Box width="100%">
      <PackageHeader header={header} subheader={subheader} features={features} />
    </Box>
  );
};

PackageHeaderSection.defaultProps = {
  reviews: [],
  reviewsMeta: null,
  isFetchingReviews: false,
};

PackageHeaderSection.propTypes = {
  listing: propTypes.listing.isRequired,
  packageId: string.isRequired,
  listingParams: shape({}).isRequired,
  reviews: array,
  reviewsMeta: shape({
    customerAverageRating: string,
  }),
  isFetchingReviews: bool,
  intl: intlShape.isRequired,
};

export default PackageHeaderSection;
